import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import CrudActionContainer from './CrudActionContainer';
import { getActionHookBuilder } from './action-hook-builder';

class VisitorCRUDActions extends CrudActionContainer {
  retrieveData: string;

  constructor() {
    super('VISITOR');
    this.retrieveData = super.makeActionKey('RETRIEVE_DATA');
  }

  getVisitorId() {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const apiKey = FINGERPRINT_PUBLIC_API_KEY;
        if (!apiKey) {
          return;
        }

        const fpAgent = await FingerprintJS.load({
          apiKey,
        });
        const { visitorId } = await fpAgent.get();

        if (!visitorId) {
          return;
        }
        dispatch({
          type: this.retrieveData,
          entity: { visitorId },
        });
        return visitorId;
      } catch (e) {}
    };
  }
}

const visitorCRUDActions = new VisitorCRUDActions();

export default visitorCRUDActions;

export const useVisitorCRUDActions = getActionHookBuilder(visitorCRUDActions, [
  'getVisitorId',
]);
